import styled from "@emotion/styled";

import { Button } from "@livechat/design-system-react-components";

export const LinkButtonGroup = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  width: 100%;
  margin-top: 12px;

  & > * {
    margin-right: 6px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const LinkButton = styled(Button)`
  flex-shrink: 0;
`;
